import { WithStyle } from '@medly-components/utils';
import type { FC } from 'react';

import BackButton from './BackButton';
import * as Styled from './Header.styled';
import { HeaderStaticComponents } from './types';

Styled.Header.displayName = 'Header';
export const Header: FC & WithStyle & HeaderStaticComponents = Object.assign(Styled.Header, {
    Style: Styled.Header,
    LeftSide: Styled.LeftSide,
    RightSide: Styled.RightSide,
    BackButton
});
